import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class EntityAdd extends Component{
	render(){
		const {entities} =this.props;
		let ec = _.find(entities.permissions, (o) => {return o==='Create'});
		return (
			ec ?
				<p>
					<NavLink to={`/entidades/crear`} className="button is-small is-inm-purple">{'Agregar Entidad'}</NavLink>
				</p>:''
		)
	}
}

export default SecureLayout(EntityAdd);


// WEBPACK FOOTER //
// ./src/elements/entities/widget/entity_add.jsx